// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as $$String from "../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Pervasives from "../../../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_format from "../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Json_encode from "../../../../../../../node_modules/@glennsl/bs-json/src/Json_encode.bs.js";
import * as PartnerStatus from "../../partner/entity/PartnerStatus.bs.js";
import * as PartnerEngagement from "./PartnerEngagement.bs.js";
import * as PartnerLoginStatus from "../../partner/entity/PartnerLoginStatus.bs.js";
import * as PartnerActiveStatusFilter from "./PartnerActiveStatusFilter.bs.js";

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var geo_region_id = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "geo_region_id"), null));
  if (geo_region_id.TAG === /* Ok */0) {
    var vehicle_id = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_id"), null));
    if (vehicle_id.TAG === /* Ok */0) {
      var engagement_type = Decco.optionFromJson((function (param) {
              return Decco.listFromJson(PartnerEngagement.t_decode, param);
            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "engagement_type"), null));
      if (engagement_type.TAG === /* Ok */0) {
        var status = Decco.optionFromJson((function (param) {
                return Decco.listFromJson(PartnerStatus.t_decode, param);
              }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
        if (status.TAG === /* Ok */0) {
          var availability = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "availability"), null));
          if (availability.TAG === /* Ok */0) {
            var gps_location = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "gps_location"), null));
            if (gps_location.TAG === /* Ok */0) {
              var active_status = Decco.optionFromJson(PartnerActiveStatusFilter.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "active_status"), null));
              if (active_status.TAG === /* Ok */0) {
                var login_status = Decco.optionFromJson(PartnerLoginStatus.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "login_status"), null));
                if (login_status.TAG === /* Ok */0) {
                  var msisdn = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "msisdn"), null));
                  if (msisdn.TAG === /* Ok */0) {
                    var driver_name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "driver_name"), null));
                    if (driver_name.TAG === /* Ok */0) {
                      var cluster_name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "cluster_name"), null));
                      if (cluster_name.TAG === /* Ok */0) {
                        var vehicle_number = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_number"), null));
                        if (vehicle_number.TAG === /* Ok */0) {
                          return {
                                  TAG: /* Ok */0,
                                  _0: {
                                    geo_region_id: geo_region_id._0,
                                    vehicle_id: vehicle_id._0,
                                    engagement_type: engagement_type._0,
                                    status: status._0,
                                    availability: availability._0,
                                    gps_location: gps_location._0,
                                    active_status: active_status._0,
                                    login_status: login_status._0,
                                    msisdn: msisdn._0,
                                    driver_name: driver_name._0,
                                    cluster_name: cluster_name._0,
                                    vehicle_number: vehicle_number._0
                                  }
                                };
                        }
                        var e = vehicle_number._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".vehicle_number" + e.path,
                                  message: e.message,
                                  value: e.value
                                }
                              };
                      }
                      var e$1 = cluster_name._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".cluster_name" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                              }
                            };
                    }
                    var e$2 = driver_name._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".driver_name" + e$2.path,
                              message: e$2.message,
                              value: e$2.value
                            }
                          };
                  }
                  var e$3 = msisdn._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".msisdn" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                          }
                        };
                }
                var e$4 = login_status._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".login_status" + e$4.path,
                          message: e$4.message,
                          value: e$4.value
                        }
                      };
              }
              var e$5 = active_status._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".active_status" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                      }
                    };
            }
            var e$6 = gps_location._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".gps_location" + e$6.path,
                      message: e$6.message,
                      value: e$6.value
                    }
                  };
          }
          var e$7 = availability._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".availability" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
        }
        var e$8 = status._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".status" + e$8.path,
                  message: e$8.message,
                  value: e$8.value
                }
              };
      }
      var e$9 = engagement_type._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".engagement_type" + e$9.path,
                message: e$9.message,
                value: e$9.value
              }
            };
    }
    var e$10 = vehicle_id._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".vehicle_id" + e$10.path,
              message: e$10.message,
              value: e$10.value
            }
          };
  }
  var e$11 = geo_region_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".geo_region_id" + e$11.path,
            message: e$11.message,
            value: e$11.value
          }
        };
}

function getListToStringParam(items, conv) {
  var join = function (lst, delimeter) {
    if (!lst) {
      return "";
    }
    var tail = lst.tl;
    var head = lst.hd;
    if (tail) {
      return Curry._1(conv, head) + ("," + join(tail, delimeter));
    } else {
      return Curry._1(conv, head);
    }
  };
  return join(items, "");
}

function getEngagementListToString(a) {
  return getListToStringParam(a, PartnerEngagement.to_string);
}

function getStatusListToString(a) {
  return getListToStringParam(a, PartnerStatus.toString);
}

function getFromDict(dict, key, fromString) {
  var strOpt = Js_dict.get(dict, key);
  return Belt_Option.flatMap(strOpt, (function (str) {
                if (str.length !== 0) {
                  return Caml_option.some(Curry._1(fromString, str));
                }
                
              }));
}

function getFromDictString(dict, key) {
  var strOpt = Js_dict.get(dict, key);
  return Belt_Option.flatMap(strOpt, (function (str) {
                return str;
              }));
}

function fromDict(map) {
  return {
          geo_region_id: Belt_Option.mapWithDefault(getFromDictString(map, "geo_region_id"), undefined, (function (v) {
                  return Caml_format.caml_int_of_string(v);
                })),
          vehicle_id: Belt_Option.mapWithDefault(getFromDictString(map, "vehicle_id"), undefined, (function (v) {
                  return Caml_format.caml_int_of_string(v);
                })),
          engagement_type: Belt_Option.mapWithDefault(getFromDictString(map, "engagement_type"), undefined, (function (v) {
                  return List.map(PartnerEngagement.from_string, $$String.split_on_char(/* ',' */44, v));
                })),
          status: Belt_Option.mapWithDefault(getFromDictString(map, "status"), undefined, (function (v) {
                  return List.map(PartnerStatus.fromString, $$String.split_on_char(/* ',' */44, v));
                })),
          availability: Belt_Option.mapWithDefault(getFromDictString(map, "availability"), undefined, Pervasives.bool_of_string_opt),
          gps_location: Belt_Option.mapWithDefault(getFromDictString(map, "gps_location"), undefined, Pervasives.bool_of_string_opt),
          active_status: Belt_Option.mapWithDefault(getFromDictString(map, "active_status"), undefined, (function (v) {
                  return PartnerActiveStatusFilter.from_string(v);
                })),
          login_status: Belt_Option.mapWithDefault(getFromDictString(map, "login_status"), undefined, (function (v) {
                  return PartnerLoginStatus.fromString(v);
                })),
          msisdn: getFromDictString(map, "msisdn"),
          driver_name: getFromDictString(map, "driver_name"),
          cluster_name: getFromDictString(map, "cluster_name"),
          vehicle_number: getFromDictString(map, "vehicle_number")
        };
}

function toDict(param) {
  var params = {};
  var setVal = function (value, key) {
    params[key] = value;
    
  };
  Belt_Option.mapWithDefault(param.geo_region_id, undefined, (function (value) {
          return setVal(String(value), "geo_region_id");
        }));
  Belt_Option.mapWithDefault(param.vehicle_id, undefined, (function (value) {
          return setVal(String(value), "vehicle_id");
        }));
  Belt_Option.mapWithDefault(param.engagement_type, undefined, (function (value) {
          return setVal(getListToStringParam(value, PartnerEngagement.to_string), "engagement_type");
        }));
  Belt_Option.mapWithDefault(param.active_status, undefined, (function (value) {
          return setVal(PartnerActiveStatusFilter.to_string(value), "active_status");
        }));
  Belt_Option.mapWithDefault(param.availability, undefined, (function (value) {
          return setVal(Pervasives.string_of_bool(value), "availability");
        }));
  Belt_Option.mapWithDefault(param.gps_location, undefined, (function (value) {
          return setVal(Pervasives.string_of_bool(value), "gps_location");
        }));
  Belt_Option.mapWithDefault(param.status, undefined, (function (value) {
          return setVal(getListToStringParam(value, PartnerStatus.toString), "status");
        }));
  Belt_Option.mapWithDefault(param.login_status, undefined, (function (value) {
          return setVal(PartnerLoginStatus.toString(value), "login_status");
        }));
  Belt_Option.mapWithDefault(param.driver_name, undefined, (function (value) {
          return setVal(value, "driver_name");
        }));
  Belt_Option.mapWithDefault(param.msisdn, undefined, (function (value) {
          return setVal(value, "msisdn");
        }));
  Belt_Option.mapWithDefault(param.cluster_name, undefined, (function (value) {
          return setVal(value, "cluster_name");
        }));
  Belt_Option.mapWithDefault(param.vehicle_number, undefined, (function (value) {
          return setVal(value, "vehicle_number");
        }));
  return params;
}

function encodeToJson(request) {
  var param = Belt_Option.mapWithDefault(request.active_status, undefined, (function (d) {
          return PartnerActiveStatusFilter.to_string(d);
        }));
  var param$1 = Belt_Option.mapWithDefault(request.login_status, undefined, (function (d) {
          return PartnerLoginStatus.toString(d);
        }));
  return Json_encode.object_({
              hd: [
                "geo_region_id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), request.geo_region_id)
              ],
              tl: {
                hd: [
                  "vehicle_id",
                  Json_encode.nullable((function (prim) {
                          return prim;
                        }), request.vehicle_id)
                ],
                tl: {
                  hd: [
                    "engagement_type",
                    Json_encode.nullable((function (param) {
                            return Json_encode.list((function (prim) {
                                          return prim;
                                        }), param);
                          }), Belt_Option.mapWithDefault(request.engagement_type, undefined, (function (a) {
                                return List.map(PartnerEngagement.to_string, a);
                              })))
                  ],
                  tl: {
                    hd: [
                      "msisdn",
                      Json_encode.nullable((function (prim) {
                              return prim;
                            }), request.msisdn)
                    ],
                    tl: {
                      hd: [
                        "active_status",
                        Json_encode.nullable((function (prim) {
                                return prim;
                              }), param)
                      ],
                      tl: {
                        hd: [
                          "availability",
                          Json_encode.nullable((function (prim) {
                                  return prim;
                                }), request.availability)
                        ],
                        tl: {
                          hd: [
                            "gps_location",
                            Json_encode.nullable((function (prim) {
                                    return prim;
                                  }), request.gps_location)
                          ],
                          tl: {
                            hd: [
                              "status",
                              Json_encode.nullable((function (param) {
                                      return Json_encode.list((function (prim) {
                                                    return prim;
                                                  }), param);
                                    }), Belt_Option.mapWithDefault(request.status, undefined, (function (a) {
                                          return List.map(PartnerStatus.toString, a);
                                        })))
                            ],
                            tl: {
                              hd: [
                                "login_status",
                                Json_encode.nullable((function (prim) {
                                        return prim;
                                      }), param$1)
                              ],
                              tl: {
                                hd: [
                                  "driver_name",
                                  Json_encode.nullable((function (prim) {
                                          return prim;
                                        }), request.driver_name)
                                ],
                                tl: {
                                  hd: [
                                    "cluster_name",
                                    Json_encode.nullable((function (prim) {
                                            return prim;
                                          }), request.cluster_name)
                                  ],
                                  tl: {
                                    hd: [
                                      "vehicle_number",
                                      Json_encode.nullable((function (prim) {
                                              return prim;
                                            }), request.vehicle_number)
                                    ],
                                    tl: /* [] */0
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

export {
  t_decode ,
  getListToStringParam ,
  getEngagementListToString ,
  getStatusListToString ,
  getFromDict ,
  getFromDictString ,
  fromDict ,
  toDict ,
  encodeToJson ,
  
}
/* No side effect */
